module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_black_friday_2025.0a4f51f5.jpg";